import {
  createStatusBadgeOptions,
  prepareDataForDropdown,
} from '../../../../../components/organisms/Filters/utils';
import { Constants, Field_Keys } from '../../../../../constants';
import useFetchData from '../../../../../hooks/fetchHook';
import { mergeDeep } from '../../../../../lib/js';
import { DC } from '../controllers/variables';

export const useGetFilters = ({ ignore }) => {
  const [{ data, isLoading = true, isError, error }, _, refetchFilters] =
    useFetchData('products/filters', {
      formatter,
      ignore,
    });

  return {
    data,
    isLoading,
    isError,
    error,
    refetchFilters,
  };
};

export const formatter = data => {
  const { sorters, categories, brands } = data;

  const newOps = {};

  newOps[DC.LOCATION] = prepareDataForDropdown(
    sorters,
    Field_Keys.SORTER.NAME,
    Field_Keys.SORTER.ID
  );

  newOps[DC.BRANDS] = prepareDataForDropdown(
    brands,
    Field_Keys.PRODUCT.BRAND_NAME,
    Field_Keys.PRODUCT.BRAND_ID,
    {
      sectionTitle: 'Others',
    }
  );

  newOps[DC.PRODUCT_CATEGORY] = prepareDataForDropdown(
    categories,
    Field_Keys.CATEGORY.FULL,
    Field_Keys.CATEGORY.SUBCATEGORY_ID
  );

  newOps[DC.PRODUCT_STATUS] = [
    {
      section: DC.OTHERS,
      options: filterStatusOptions(),
    },
  ];

  return newOps;
};

const filterStatusOptions = () => {
  const casesStatus = mergeDeep({}, Constants.DropdownStatus);
  delete casesStatus.Sideload;
  const singleStatus = Object.values(casesStatus).filter(
    status => status.split('_').length < 2
  );

  return createStatusBadgeOptions(singleStatus);
};
